import AirDatepicker from "air-datepicker";
import localeEn from "air-datepicker/locale/en";

export const FiltersDatepicker = () => {
  const containers = Array.from(
    document.querySelectorAll(".filters__datepicker")
  );

  if (!containers.length) return;

  containers.forEach((container) => {
    const datepicker = container.querySelector(".filters__datepicker-input");

    if (!datepicker) return;

    new AirDatepicker(datepicker, {
      locale: localeEn,
      dateFormat: "dd.MM.yy",
      range: true,
      multipleDatesSeparator: " - ",
      onShow() {
        container.classList.add("active");
      },
      onHide() {
        container.classList.remove("active");
      },
      onSelect({datepicker: dp}) {
        const applyBtn = dp.$datepicker.querySelector(".filters__apply");
        if (!applyBtn) return;

        if (dp.selectedDates.length === 2) {
          applyBtn.classList.remove("d-none");
        } else {
          applyBtn.classList.add("d-none");
        }
      },
      buttons: [
        {
          content() {
            return `<span class="button button--no-arrow filters__apply d-none">Apply</span>`;
          },
          onClick(dp) {
            console.log("apply filters date", dp.selectedDates);

            dp.hide();
          },
        },
      ],
    });
  });
};
